import React from "react";
import styles from "./Input.module.css";

const Input = ({ name, label, value, isTextArea, onChange }) => {
  const componentProps = {
    value,
    required: true,
    name,
    minLength: isTextArea ? 10 : 5,
    maxLength: isTextArea ? 500 : 50,
    onChange,
    className: styles.input,
  };
  return (
    <div className={styles.content}>
      <label htmlFor="message_text" className={styles.label}>
        {label}
      </label>
      {isTextArea ? (
        <textarea {...componentProps} rows={7} />
      ) : (
        <input {...componentProps} />
      )}
    </div>
  );
};

export default Input;
